import { Controller } from "@hotwired/stimulus";

// The share section's client half (#63/#65): copying a share link or an
// embed snippet. The payload travels as an action param on the row's
// buttons — no DOM reading, the server-rendered text stays presentation.
// "text", not "url": the embed button's param carries a whole <iframe>
// tag.
export default class extends Controller {
  // Clipboard access needs a secure context (localhost counts). Failure
  // flips to the failed label instead of staying silent: the LINK is
  // selectable text right next to its button, but the embed snippet
  // exists nowhere else in the DOM — with no feedback the owner would
  // have no way to know the click did nothing.
  async copy(event) {
    const button = event.currentTarget;
    const { copiedLabel, failedLabel } = button.dataset;
    // Rejects a click while the label is flipped — and the restore
    // values are captured HERE, before the await: two clicks inside the
    // clipboard-write window both pass this guard, and a post-await
    // read would capture the first click's flip as the second click's
    // restore value, leaving the button permanently dead on its own
    // guard.
    if ([copiedLabel, failedLabel].includes(button.textContent)) return;
    const label = button.textContent;
    const ariaLabel = button.getAttribute("aria-label");

    let flip = copiedLabel;
    try {
      await navigator.clipboard.writeText(event.params.text);
    } catch {
      flip = failedLabel;
    }
    // aria-label flips WITH the text: the static label would otherwise
    // talk over the change, and the aria-live region announces it. The
    // failure flip also wears the section's error colour — a grey word
    // identical to the resting state is the weakest form of visible.
    button.textContent = flip;
    button.setAttribute("aria-label", flip);
    button.classList.toggle("text-destructive", flip === failedLabel);
    setTimeout(() => {
      button.textContent = label;
      button.setAttribute("aria-label", ariaLabel);
      button.classList.remove("text-destructive");
    }, 1500);
  }
}
